import { EditPeriodScreen } from "@/components/screens/settings/EditPeriodScreen"
import { useUpdateAndRegenerateReport } from "@/queries/useReport"
import { useNavigate } from "@/router"
import { currentAuthAtom } from "@/state/auth"
import { periodDraftAtom } from "@/state/draft/period"
import { reportFormDraftAtom } from "@/state/report"
import { useAnalytics } from "@/hooks/use-analytics"
import { useAtom, useAtomValue } from "jotai"
import { useEffect } from "react"

export default function EditPeriodPage() {
	const navigate = useNavigate()
	const form = useAtomValue(reportFormDraftAtom)
	const [state, setState] = useAtom(periodDraftAtom)
	const auth = useAtomValue(currentAuthAtom)
	const { run, generating } = useUpdateAndRegenerateReport()
	const analytics = useAnalytics("Edit_Period")

	useEffect(() => {
		analytics.sendEvent("Step_Period__View")
	}, [])
	return (
		<EditPeriodScreen
			reportId={auth.reportId}
			onSave={(data) => {
				setState(data)
				analytics.sendEvent("Step_Period__Save")
				run(form)
			}}
			value={state}
			onSaveLocal={(data) => {
				setState(data)
			}}
			savingInProcess={generating}
		/>
	)
}
